import React from 'react'
import { YStack } from 'tamagui'

import { H2 } from '@newComponents/Text'

export const DocSection = ({
  id,
  title,
  children,
}: {
  id: string
  title: string
  children: React.ReactNode
}) => (
  <YStack tag='section' id={id} gap='$4'>
    <H2>{title}</H2>
    {children}
  </YStack>
)
